import { createFileRoute, redirect } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey, ArticlePath, createGuideLink, FeatureFlag } from '@mews-commander/enums';
import { PageHeaderActionsPortal, GuideLinkButton } from '@mews-commander/ui';
import { BillingTab } from '@mews-commander/modules/src/modules/customerDetail';
import { getCustomerNameForDocumentTitle } from '../-utils/getCustomerNameForDocumentTitle';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Customer/$id/_pageLayout/Billing')({
    beforeLoad: ({ context: { featureFlagService }, params }) => {
        if (!featureFlagService.hasFlag(FeatureFlag.newCustomerPageRouteStructureEnabled)) {
            throw redirect({
                to: '/$currentEnterpriseId/Customer/Billing/$id',
                params,
                search: { EnterpriseId: params.currentEnterpriseId },
            });
        }
    },
    loader: async ({ params: { id }, context: { ensureQueryData } }) =>
        await getCustomerNameForDocumentTitle({ ensureQueryData, id }),
    component: Component,
    staticData: {
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
        title: TextKey.Billing,
    },
});

function Component() {
    const { id } = Route.useParams();

    return (
        <>
            <PageHeaderActionsPortal>
                <GuideLinkButton guideLink={createGuideLink(ArticlePath.TakePayment)} />
            </PageHeaderActionsPortal>
            <BillingTab id={id} />
        </>
    );
}
